export const ErrorMessage = "An error occurred. This could be due to a slow internet connection. Please try again later or contact the administrator.";